import { Button, TextareaAutosize, LinearProgress, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress } from '@material-ui/core'
import React, { useRef, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import "../styles/Noticeview.css"
import { myBucket } from '../services/UploadService'
import { ApiURL } from '../constants/ApiUrl'
import { findLastKey } from 'lodash'

function NoticeMemberView() {
    const [update, setUpdate] = useState(false)
    const [Progress, setProgress] = useState(0)
    const [Editable, setEditable] = useState(false)
    const [TempDetails, setTempDetails] = useState({})
    const [allDetails, setallDetails] = useState([])
    const [date, setDate] = useState("")


    const [imgList, setImgList] = useState([])
    const value = localStorage.getItem("Notice")

    useEffect(() => {
        getData(value)
    }, [])

    const getData = async (value) => {
        const result = await axios.get(`${ApiURL}/api/get_notice_by_id/${value}`);
        setDate(result.data.msg.createdAt)
        setallDetails(result.data.msg)
        console.log(result.data.msg.createdAt, "dateeeeeee")
        const a = []
        result.data.msg.urls.map((item) => {
            if (item.path !== undefined) {
                a.push(item.path)
            }
        })
        setImgList(a)

    }
    return (
        <>
            <div style={{ textAlign: 'center', padding: '0 0 50px 0' }}>
                <h1>Notice</h1>
                <div className="applicationContainer table" style={{  margin: "auto" }}>
                    <table  className="applicationTable">
                        <tr>
                            <td colSpan="2"><b><u>Notice Details</u></b></td>
                        </tr>
                        <tr>
                            <td>Title</td>
                            <td>{allDetails.subject}</td>
                        </tr>
                        <tr>
                            <td>Notice</td>
                            <td>{allDetails.text}</td>
                        </tr>
                        <tr>
                            <td>Date</td>
                            <td>{new Date(allDetails.createdAt).getDate() + '/' + (new Date(allDetails.createdAt).getMonth() + 1) + '/' + new Date(allDetails.createdAt).getFullYear()}</td>
                        </tr>
                        <tr>
                            <td colSpan="2"><b><u>Notice Document</u></b></td>
                        </tr>
                        {imgList.map((itm, count) => (
                            <tr>
                                <td>Document {count + 1} </td>
                                <td><a href={itm} target="_blank" rel="noreferrer">Click Here to View</a></td>
                            </tr>
                        ))}
                    </table>
                </div>
            </div>

        </>
    )
}
export default NoticeMemberView;
